/* Renders the Routes component */

import React from 'react';
import Routes from './routes';
import './App.css';

const App = ({ isWatchman = false }) => {
    return <Routes isWatchman={process.env.REACT_APP_THEME_ENV === 'watchman' || isWatchman} />;
};

export default App;
